import { EntityInterface }      from '@shared/model/entity/entity.interface';

export abstract class EntityModel implements EntityInterface {
  public readonly uuid!: string;
  public readonly created_at!: string;
  public readonly updated_at!: string;
}
